'use client';

import { FC, useEffect, useRef, useState } from 'react';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { COLORS } from '@/constants';
import { ExpandTextIcon } from '@/components';
import { Container, TextBox } from './styled';

type DescriptionShellProps = {
  children: React.ReactNode;
};

export const DescriptionShell: FC<DescriptionShellProps> = ({ children }) => {
  const t = useTranslations();
  const [showToggle, setShowToggle] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setShowToggle(contentRef.current.scrollHeight > 200);
    }
  }, []);

  return (
    <Container>
      <TextBox $isExpanded={isExpanded} ref={contentRef}>
        {children}
      </TextBox>
      {showToggle && (
        <Typography
          fontWeight={600}
          fontSize={16}
          color={COLORS['primary/500']}
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        >
          {isExpanded
            ? t('housingCardDetails.buttons.hideFullDesc')
            : t('housingCardDetails.buttons.openFullDesc')}
          <ExpandTextIcon isExpanded={isExpanded} />
        </Typography>
      )}
    </Container>
  );
};
